import React from "react";

const ArrowRight = () => {
  return (
    <>
      <svg
        width="26"
        height="12"
        viewBox="0 0 26 12"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M25.3071 6.53033C25.6 6.23744 25.6 5.76256 25.3071 5.46967L20.5341 0.696699C20.2412 0.403806 19.7663 0.403806 19.4734 0.696699C19.1805 0.989593 19.1805 1.46447 19.4734 1.75736L23.7161 6L19.4734 10.2426C19.1805 10.5355 19.1805 11.0104 19.4734 11.3033C19.7663 11.5962 20.2412 11.5962 20.5341 11.3033L25.3071 6.53033ZM0.104126 6.75L24.7767 6.75V5.25L0.104126 5.25L0.104126 6.75Z"
          fill="#FCFFFE"
        />
      </svg>
    </>
  );
};

export default ArrowRight;
